import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function addUserAuthorization(locationId, userId, authorization = []) {
	const query = gql`
		mutation addUserAuthorization($locationId: String!, $userId: String!, $input: [UserAuthorizationInput]) {
			addUserAuthorization(locationId: $locationId, userId: $userId, input: $input) {
				_id
				auth {
					_id
					locationId
					actions {
						_id
						actionKey
						actionName
						actionDescription
						category
					}
					groups {
						_id
						locationId
						groupName
						groupDescription
						groupActions
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		userId,
		input: authorization,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.addUserAuthorization;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function addUserAuthorizationLocation(locationId, userId, authorizedLocation) {
	const query = gql`
		mutation addUserAuthorizationLocation($locationId: String!, $userId: String!, $authorizedLocation: String) {
			addUserAuthorizationLocation(locationId: $locationId, userId: $userId, authorizedLocation: $authorizedLocation) {
				_id
				auth {
					_id
					locationId
					actions {
						_id
						actionKey
						actionName
						actionDescription
						category
					}
					groups {
						_id
						groupName
						groupDescription
						groupActions
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		userId,
		authorizedLocation,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.addUserAuthorizationLocation;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function deleteUserAuthorization(locationId, userId, authorization = []) {
	const query = gql`
		mutation deleteUserAuthorization($locationId: String!, $userId: String!, $input: [UserAuthorizationInput]) {
			deleteUserAuthorization(locationId: $locationId, userId: $userId, input: $input) {
				_id
				auth {
					_id
					locationId
					actions {
						_id
						actionKey
						actionName
						actionDescription
						category
					}
					groups {
						_id
						groupName
						groupDescription
						groupActions
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		userId,
		input: authorization,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.deleteUserAuthorization;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function deleteUserAuthorizationLocation(locationId, userId, authorizedLocation) {
	const query = gql`
		mutation deleteUserAuthorizationLocation($locationId: String!, $userId: String!, $authorizedLocation: String) {
			deleteUserAuthorizationLocation(locationId: $locationId, userId: $userId, authorizedLocation: $authorizedLocation) {
				_id
				auth {
					_id
					locationId
					actions {
						_id
						actionKey
						actionName
						actionDescription
						category
					}
					groups {
						_id
						groupName
						groupDescription
						groupActions
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		userId,
		authorizedLocation,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.deleteUserAuthorizationLocation;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}
